import {
  Home,
  FileText,
  FileClock,
  FileKey2,
  Receipt,
  Briefcase,
  FilePlus,
  Users,
  Settings,
  User,
  Menu,
  FileWarning,
  StickyNote,
  ListTodo,
  TrendingDown,
  ChevronsUpDown,
  Download,
  Pencil,
  Plus,
  Trash2,
  Loader2,
  UploadCloud,
  Eye,
  CreditCard,
  FileSpreadsheet,
  Replace,
  Ban,
  Save,
  Shield,
} from 'lucide-react';

// --- Iconos para la Navegación Principal ---
export const HomeIcon = Home;
export const DocumentIcon = FileText; // Usado para Presupuestos/PDFs
export const QuoteIcon = FileClock;
export const CreditNoteIcon = FileKey2;
export const InvoiceIcon = Receipt;
export const ClientsIcon = Briefcase;
export const ProductsIcon = FilePlus;
export const UsersIcon = Users;
export const SettingsIcon = Settings;
export const UserIcon = User;
export const MenuIcon = Menu;
export const NoteIcon = StickyNote;
export const TaskIcon = ListTodo;
export const TrendingDownIcon = TrendingDown; // Gastos (Corregido)

// --- Iconos Específicos de Páginas y Componentes ---
export const RectificativaIcon = FileWarning;

// --- Iconos de Acción y UI ---
export const PencilIcon = Pencil;
export const PlusIcon = Plus;
export const TrashIcon = Trash2;
export const ChevronsUpDownIcon = ChevronsUpDown; // Para tablas ordenables
export const DownloadIcon = Download;           // Para descargas genéricas
export const UploadCloudIcon = UploadCloud;       // Para subida de ficheros
export const Loader2Icon = Loader2;             // Indicador de carga
export const EyeIcon = Eye;                     // Para previsualizar
export const CreditCardIcon = CreditCard;       // Para abonos/pagos
export const ExcelIcon = FileSpreadsheet;       // Para exportar a Excel
export const ConvertIcon = Replace;             // Para convertir (ej. presupuesto a factura)
export const BanIcon = Ban;                     // Para cancelar/prohibir
export const SaveIcon = Save;                   // Para guardar
export const ShieldIcon = Shield;               // Para protección/seguridad
